import React from 'react';
import { Box, Text, VStack } from '@chakra-ui/react';
import { PendingCardTransactionsStatusDTO, PendingCardTransactionStatus, Res, TicketDTO } from 'core/api';
import { asLocationDescription } from 'core/ui/controls/Format';

export type PendingCardTransactionsStatusProps = {
	ticket: TicketDTO;
	transactions: PendingCardTransactionsStatusDTO[];
};

export default function ShowPendingCardTransactionsStatus(props: PendingCardTransactionsStatusProps) {

	const { ticket, transactions } = props;

	return <>
		<Box gap={'4'} alignItems={'left'}>
			<Text fontSize={'md'} fontWeight={'bold'} textAlign={'left'}>{Res.Web.PENDING_CARD_TRANSACTIONS_STATUS_TICKET(asLocationDescription(ticket), ticket.NetAmount)}</Text>
		</Box>
		<VStack gap={'4'} alignItems={'left'}>
			{transactions.map((transaction, index) => (
				<Text key={index} fontSize={'md'} textAlign={'left'}>
					{Res.Web.PENDING_CARD_TRANSACTIONS_STATUS_TRANSACTION_STATUS(transaction.Amount, PendingCardTransactionStatus.toString(transaction.Status))}
				</Text>
			))}
		</VStack>
	</>;
}